import {ValidationObserver, ValidationProvider} from "vee-validate";
import {ContentStatus} from "@/enums/ContentStatus";
import {ContentTypes} from "@/enums/ContentTypes";
import {OrientationTypes} from "@/enums/OrientationTypes";
import {ContentCreatorTypes} from "@/enums/ContentCreatorTypes";

export default {
    name: "ContentCreatorDlg",
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            dialog: false,
            loading: false,
            title: "",
            name: "",
            type: "",
            contentCreatorType: "",
            contentData: {},
            freeDesignIcon: require("@/assets/icons/free-design.png"),
            templatesIcon: require("@/assets/icons/templates.png")
        }
    },
    computed: {
        contentTypes() {
            return ContentTypes.DigitalSignagePage;
        },
        orientationTypes() {
            return OrientationTypes;
        },
        contentCreatorTypes() {
            return ContentCreatorTypes;
        }
    },
    methods: {
        open(title: string, data: string[]) {
            this.dialog = true;
            this.title = title ?? "";
            this.contentData = data;
        },
        close() {
            this.dialog = false;
            this.loading = false;
            this.name = "";
            this.type = "";
            this.$refs.observer.reset();
        },
        async submit() {
            this.loading = true;

            let defaultContent;

            if(this.contentCreatorType === this.contentCreatorTypes.FreeDesign) {
                defaultContent = '<div class="is-section is-box is-section-100 type-poppins box-autofit type-system-ui box-canvas autolayout last-box scroll-target"><div class="is-block" style="height: 150px; width: 40%;"><div class="is-container v2 is-content-700 leading-14 size-18"></div></div></div>'
            } else {
                defaultContent = '<div class="is-section is-box is-section-100 type-poppins box-autofit"><div class="is-overlay"></div><div class="is-boxes"><div class="is-box-centered is-opacity-95"><div class="is-container v2 is-content-700 leading-14 size-18"></div></div></div></div>'
            }

            const content = {
                facilityId: this.$store.state.authModule.currentFacility,
                name: this.name,
                type: this.type,
                contentCreatorType: this.contentCreatorType,
                status: ContentStatus.Draft,
                createdBy: this.$store.state.authModule.user.name,
                datePublished: '',
                html: this.contentData?.html ?? defaultContent,
                mainCss: this.contentData?.mainCss ?? '',
                sectionCss: this.contentData?.sectionCss ?? '',
                orientation: this.type === ContentTypes.DigitalSignagePage ? this.orientationTypes.Landscape : this.orientationTypes.Portrait,
            }

            this.$store.dispatch("addCreatorContent", content).then(async contentId => {
                await this.$store.dispatch("getCreatorContent");

                this.$toast.open({
                    message: `Content successfully added`,
                    type: "success"
                });
                this.close();

                setTimeout(() => {
                    this.$router.push('/content-list/' + contentId);
                }, 500)
            }).catch((error) => {
                this.$toast.open({
                    message: `${error.message}`,
                    type: "error"
                });
            })
        }
    }
}